import React, { useState, useEffect, useRef } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import pgVideo from 'yet-another-react-lightbox/plugins/video'

function Videos() {
  const [isloading, setIsLoading] = useState(true)
  const [listevideos, setListeVideos] = useState([])

  useEffect(() => {
    // Chargez les données à partir du fichier JSON
    fetch('./json/playlistvideos.json')
      .then((response) => response.json())
      .then((data) => {
        setListeVideos(data)
        setIsLoading(true)
      })
      .catch((error) =>
        console.error('Erreur lors du chargement des photos:', error)
      )
  }, [])

  const slides = listevideos.map(({ src, type, poster }) => ({
    type: 'video',
    width: 1280,
    height: 720,
    poster: poster,
    sources: [
      {
        src: src,
        type: type,
      },
    ],
  }))

  const handleClose = () => {
    setIsLoading(false)
    // Rediriger vers la page principale ou effectuer une autre action
    window.location.href = '/'
  }

  const thumbnailsRef = useRef(null)

  return (
    // <div id="Videos">
    <Lightbox
      open={isloading}
      close={() => handleClose()}
      slides={[...slides]}
      plugins={[Thumbnails, pgVideo]}
      thumbnails={{ ref: thumbnailsRef }}
      on={{
        click: () => {
          ;(thumbnailsRef.current?.visible
            ? thumbnailsRef.current?.hide
            : thumbnailsRef.current?.show)?.()
        },
      }}
    />
    // </div>
  )
}

export default Videos
